import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Button } from '@components/button';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';

import { Box } from 'components/Box';
import { UnauthedPage } from 'components/unauthed-page';

export const SigninSMS = observer((props) => {
  const { code, onChange, onSubmit, error, disableSubmit, t } = props;

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      onSubmit();
    }
  }

  let submitLabel = disableSubmit
    ? t('signin.twofactor.button.submitting')
    : t('signin.twofactor.button.submit');

  return (
    <UnauthedPage>
      <Text font="heading1">{t('signin.sms.heading')}</Text>
      <Text>{t('signin.sms.subheading')}</Text>
      <Box mt="24">
        <TextField
          label={t('signin.twofactor.label.code')}
          value={code}
          error={error}
          onChange={(val) => onChange('code', val)}
          isDisabled={disableSubmit}
          onKeyPress={handleKeyPress}
        />
      </Box>
      <Actions justifyContent="space-between" alignItems="center" mt="24">
        <Button isDisabled={disableSubmit} onClick={onSubmit} text={submitLabel} />
      </Actions>
    </UnauthedPage>
  );
});

const Actions = styled(Box)((p) => ({
  display: 'flex',
  [p.theme.mobileQuery]: {
    display: 'block',
    '> *': {
      textAlign: 'center',
      width: '100%',
    },
    '> a': {
      display: 'block',
      marginTop: p.theme.spacing.m12,
    },
  },
}));
